import React from "react";

interface IntegrationItem {
  name: string;
  displayName?: string;
  enabled: boolean;
}

interface Props {
  items: IntegrationItem[];
  active: string | null;
  onSelect: (name: string) => void;
}

export default function IntegrationList({ items, active, onSelect }: Props) {
  return (
    <div className="integration-list">
      {items.map((i: IntegrationItem) => (
        <div
          key={i.name}
          className={`integration-item ${active === i.name ? "active" : ""}`}
          onClick={() => onSelect(i.name)}
        >
          <span>{i.displayName || i.name}</span>
          {i.enabled && <span className="enabled-dot" />}
        </div>
      ))}
    </div>
  );
}
